import * as React from 'react';
import {
    performVerticalAutoScroll,
    terminateAutoScroll,
} from '../../utils/performVerticalAutoScroll';
import { SurfaceConstants } from 'owa-calendar-surface-core';
import { SurfaceEventHandlers } from '../../interfaces/SurfaceEventHandlers';

/**
 * Starts auto scrolling of provided scroll region on mouseDown event
 * when mouse position is close to top or bottom edges.
 */
export class AutoScrollBehavior extends React.Component<{}, {}> {
    private scrollElement: HTMLElement;
    private scrollRect: ClientRect;

    render() {
        return null;
    }

    handlers(): SurfaceEventHandlers {
        return {
            onMouseDown: this.onMouseDown,
        };
    }

    private onMouseDown = (evt: React.MouseEvent<HTMLElement>) => {
        this.scrollElement = evt.currentTarget as HTMLDivElement;
        this.scrollRect = this.scrollElement.getBoundingClientRect();
        if (
            evt.pageY - this.scrollRect.top >
            this.scrollRect.height - SurfaceConstants.ScrollbarWidth
        ) {
            // Do not activate behavior if event comes from scrollbar overlay
            return;
        }
        document.addEventListener('mousemove', this.onMouseMove);
        document.addEventListener('mouseup', this.onMouseUp);
        // This is needed here to work around the fact that during dnd operations, we will *not* get
        // a mouseup event, so we treat a drop operation as a mouse up.
        this.scrollElement.ondrop = this.onMouseUp;

        performVerticalAutoScroll(this.scrollElement, this.scrollRect, evt.pageY);
    };

    private onMouseMove = (ev: MouseEvent) => {
        performVerticalAutoScroll(this.scrollElement, this.scrollRect, ev.pageY);
    };

    private onMouseUp = (ev: MouseEvent) => {
        terminateAutoScroll(this.scrollElement);

        this.scrollElement.onmousemove = null;
        document.removeEventListener('mousemove', this.onMouseMove);
        document.removeEventListener('mouseup', this.onMouseUp);
    };
}
